module.exports = __webpack_public_path__ + "static/img/img_o.ac0e4e0e.png";